const app = angular.module('asc718', [])

function asc718($scope, $window, $document) {

    $scope.sendMail = function(email, subject, message) {
        analytics.track('clicked learn more on ASC-718 marketing page');
        $window.open("mailto:"+email+"?subject="+subject+"&body="+message,"_self");
    };

    $scope.enlargeDisclosure = false;
    $scope.enlargeJournal = false;
    $scope.enlargeValuation = false;

    angular.element($window).bind("scroll", function() {
        const disclosureTableY = angular.element($document).find('disclosure-table')[0].getBoundingClientRect().top;
        const journalTableY = angular.element($document).find('journal-table')[0].getBoundingClientRect().top;
        const valuationTableY = angular.element($document).find('valuation-table')[0].getBoundingClientRect().top;
        if (disclosureTableY < ($window.innerHeight)) {
            $scope.enlargeDisclosure = true;
        }
        if (journalTableY < ($window.innerHeight)) {
            $scope.enlargeJournal = true;
        }
        if (valuationTableY < ($window.innerHeight)) {
            $scope.enlargeValuation = true;
        }
        $scope.$apply();
    });

}

function disclosureTable() {
    return {
            restrict: 'E',
            template: require('text!./disclosure-table.html')
        }
}

function journalTable() {
    return {
        restrict: 'E',
        template: require('text!./journal-table.html')
    }
}

function valuationTable() {
    return {
        restrict: 'E',
        template: require('text!./valuation-table.html')
    }
}

app.controller('asc718', asc718)
.directive('disclosureTable', disclosureTable)
.directive('journalTable', journalTable)
.directive('valuationTable', valuationTable)



// WEBPACK FOOTER //
// ./_src/external/asc718.js